import React from "react";
import { FieldType } from "../../../services/helpers/types";
import ToggleField from "../ToggleField/ToggleField";
import { useTranslation } from "react-i18next";

interface AddBooleanFieldProps {
  field?: FieldType;
  onFieldChange: (name: string, value?: any) => void;
}

const AddBooleanField = (props: AddBooleanFieldProps) => {
  const { field, onFieldChange } = props;

  const { t } = useTranslation();

  const [defaultValue, setDefaultValue] = React.useState(
    field?.defaultValue ?? `${t("no")}`
  );

  const handleDefaultValueChange = (value: string) => {
    setDefaultValue(value);
    onFieldChange("defaultValue", value);
  };
  return (
    <div>
      <div className="dui-example-field">
        <div className="dui-example-field-title">{t("defaultValue")}:</div>
        <ToggleField value={defaultValue} onChange={handleDefaultValueChange} />
      </div>
    </div>
  );
};

export default AddBooleanField;
